var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KvButton',{attrs:{"variant":_vm.variant,"prepend-icon":_vm.copied ? _vm.successIcon : _vm.copyIcon},on:{"click":_vm.copy}},[_vm._v("\n    "+_vm._s(_vm.copied ? _vm.resolvedSuccessText : _vm.resolvedText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }